import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-email-confirm',
  templateUrl: './icon-email-confirm.component.html',
  styles: []
})
export class IconEmailConfirmComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
